import { Outlet } from 'react-router-dom'
import AppHeader from '@/app/components/AppHeader'
import {
  APP_UPDATE_BANNER_HOST,
  AppUpdateBanner,
} from '@features/shared/components/AppUpdateNotices'
import PageTrailSlotProvider from '@features/shared/components/PageTrailSlotProvider'
import TitlebarSlotProvider from '@features/shared/components/TitlebarSlotProvider'
import {
  PageSidePanelSlotProvider,
  PageSidePanelSlotTarget,
} from '@features/shared/components/PageSidePanels'
import GlobalSidebar from '@features/sidebar/components/GlobalSidebar'
import ProtectedRoute from '@features/auth/components/ProtectedRoute'
import { PanelStackProvider } from '@features/panels/components/PanelStackContext'
import GlobalPanelStack from '@features/panels/components/GlobalPanelStack'
import CreateTableDialogHost from '@features/tables/components/CreateTableDialogHost'
import ExportWatcher from '@features/exports/components/ExportWatcher'
import SendExportDialog from '@features/exports/components/SendExportDialog'
import { MicrosoftConnectionWatcher } from '@features/integrations/components/MicrosoftConnectionWatcher'

/**
 * The signed-in app's shell: AppHeader (full width) over the frame, which holds
 * GlobalSidebar | the page's left-hand panels | the page card | its right-hand
 * panels | the panel stack. TableLayout and PrivateLayout render their page
 * card inside it. The Add Table panel lives here too, so it stays open when the
 * sidebar menu that opened it closes.
 */
export default function AppShellLayout() {
  return (
    <ProtectedRoute>
      <PanelStackProvider>
        {/* The top bar hosts each page's breadcrumb trail (see pageTrailSlot),
            the frame its side panels (see pageSidePanelSlots), and a page's
            header its grid's titlebar actions (see titlebarSlot). */}
        <PageTrailSlotProvider>
          <PageSidePanelSlotProvider>
            <TitlebarSlotProvider>
              <div className="flex h-screen w-full flex-col overflow-hidden bg-[color:var(--surface-frame)]">
                {/* An update coming or in progress, above the header (AppUpdateController). */}
                <div {...{ [APP_UPDATE_BANNER_HOST]: '' }} className="contents">
                  <AppUpdateBanner />
                </div>
                {/* Grayed out while an update has frozen the page (index.css, .app-frozen). */}
                <div className="app-frozen-view flex min-h-0 flex-1 flex-col">
                  <AppHeader />
                  <div className="flex flex-1 overflow-hidden">
                    <GlobalSidebar />
                    <PageSidePanelSlotTarget side="start" />
                    <Outlet />
                    <PageSidePanelSlotTarget side="end" />
                    <GlobalPanelStack />
                  </div>
                </div>
              </div>
              <CreateTableDialogHost />
              {/* Exports run in the background; this says when one is ready. */}
              <ExportWatcher />
              {/* Send's dialog outlives the menu that opened it. */}
              <SendExportDialog />
              {/* Toasts how a background Microsoft 365 setup ends, on any page. */}
              <MicrosoftConnectionWatcher />
            </TitlebarSlotProvider>
          </PageSidePanelSlotProvider>
        </PageTrailSlotProvider>
      </PanelStackProvider>
    </ProtectedRoute>
  )
}
